import React, { useState, useEffect } from 'react';
import { ContentBox } from '../ContentBox';
import { SingleInput, SingleSelect, SingleText } from '../../Res/BaseInput';
import { SubmitButton } from '../../Res/BaseButton';
import { RespResumeOtherData, RespResumeOtherDataPayrollMethodList, RespResumeOtherPayrollMethod } from '../../../../item/ItemResume';
import { api_addResumeOtherData } from '../../../../api/apiResume';
import Swal from 'sweetalert2';
import { api_getBankName } from '../../../../api/apiSystem';
import { getItemsInfo } from '../../../../item/ItemTools';

export const OtherData_payrollMethod = "payrollMethod"
export function ContractorResumePayrollMethod({ rId, payrollMethod, companyId, setIsLoading, isEdit, isEmployee = false }) {
    const [resumeId, setResumeId] = useState("")
    const [mPayrollMethod, setmPayrollMethod] = useState([])
    const [mPayrollMethodList, setPayrollMethodList] = useState([])


    useEffect(() => {
        if (rId !== undefined && rId !== "" && rId !== resumeId) {
            setResumeId(rId)
            //console.log(rId)
            //getResumeOtherData(rId)
        }
    }, [rId])

    useEffect(() => {
        if (payrollMethod !== undefined && payrollMethod !== mPayrollMethod && Object.keys(payrollMethod).length !== 0) {
            setmPayrollMethod(payrollMethod)
            var mRespResumeOtherDataPayrollMethodList = new RespResumeOtherDataPayrollMethodList({})
            mRespResumeOtherDataPayrollMethodList.fromJson(payrollMethod.resumeData)
            setPayrollMethodList(mRespResumeOtherDataPayrollMethodList.payrollMethodList)
        }
    }, [payrollMethod])

    function setPayrollMethod(index, payrollMethod) {
        mPayrollMethodList[index] = payrollMethod
        console.log(payrollMethod)
        setPayrollMethodList(mPayrollMethodList)
    }

    /*
    function getResumeOtherData(resumeId) {
        var mReqResumeOtherData = new ReqResumeOtherData({
            resumeId,
            resumeKey: OtherData_education
        })
        //console.log(mReqResumeOtherData)
        api_getResumeOtherData({
            mReqResumeOtherData,
            success: (jsonData) => {
                //console.log(jsonData.info.resumeData)
                var mRespResumeOtherDataPayrollMethodList = new RespResumeOtherDataPayrollMethodList({})
                mRespResumeOtherDataPayrollMethodList.fromJson(jsonData.info.resumeData)
                //console.log(mRespResumeOtherDataPayrollMethodList)
                setPayrollMethodList(mRespResumeOtherDataPayrollMethodList.payrollMethodList)
                setIsLoading(false)
            },
            failure: (err) => {
                setIsLoading(false)
            }
        })
    }
    */

    async function saveOtherDataFamily() {
        //console.log("saveOtherData")
        var mRespResumeOtherData = new RespResumeOtherData({
            companyId,
            resumeId,
            resumeKey: OtherData_payrollMethod,
            resumeData: JSON.stringify(mPayrollMethodList),
        })
        try {
            await api_addResumeOtherData({
                mRespResumeOtherData,
                isEmployee
            })
            Swal.fire({
                type: 'success',
                title: '提醒',
                text: "儲存成功",
            })
        } catch (error) {
            console.log(error)
        }
    }


    var title = "薪資領取方式"
    var content =
        <>
            {
                mPayrollMethodList.map((f, i) => (
                    <PayrollMethodItems key={"pm" + i} index={i} payrollMethod={f} setPayrollMethod={setPayrollMethod} isEdit={isEdit} />
                ))
            }
            {isEdit ?
                <>
                    <div className="hr-line-dashed"></div>
                    <div className="row text-right ">
                        <div className="col-sm-12">
                            <SubmitButton name={"儲存"} action={saveOtherDataFamily} isRight={true} />
                        </div>
                    </div>
                </>
                : <></>
            }
        </>


    return (
        <>
            <ContentBox title={title} content={content} hasDrawer={true} />
        </>
    )
}

function PayrollMethodItems({ index, payrollMethod, setPayrollMethod, isEdit }) {
    const [mPayrollMethod, setP] = useState(new RespResumeOtherPayrollMethod({}))
    const [method, setMethod] = useState(1)
    const [bankCode, setBankCode] = useState("")
    const [bankName, setBankName] = useState("")
    const [bankBranchCode, setBankBranchCode] = useState("")
    const [bankBranchName, setBankBranchName] = useState("")
    const [accountName, setAccountName] = useState("")
    const [account, setAccount] = useState("")
    const [idNumber, setIdNumber] = useState("")

    const methodItems = [
        { val: "1", name: "薪資轉帳-本人" },
        { val: "2", name: "薪資轉帳-他人" },
        { val: "3", name: "領取現金" }]
    const accountNamePlaceholder = {
        1: "王大同 - 請填寫本人姓名",
        2: "王大同 - 請填寫他人姓名"
    }

    useEffect(() => {
        if (payrollMethod !== undefined && payrollMethod !== mPayrollMethod) {
            setAll(payrollMethod)
        }
    }, [payrollMethod])

    function setAll(payrollMethod) {
        setP(payrollMethod)
        setMethod(payrollMethod.method)
        setBankCode(payrollMethod.bankCode)
        setBankName(payrollMethod.bankName)
        setBankBranchCode(payrollMethod.bankBranchCode)
        setBankBranchName(payrollMethod.bankBranch)
        setAccountName(payrollMethod.accountName)
        setAccount(payrollMethod.account)
        setIdNumber(payrollMethod.idNumber)
    }

    function init(method) {
        var mRespResumeOtherPayrollMethod = new RespResumeOtherPayrollMethod({})
        mRespResumeOtherPayrollMethod.method = method
        setAll(mRespResumeOtherPayrollMethod)
        console.log(mRespResumeOtherPayrollMethod)
        setPayrollMethod(index, mRespResumeOtherPayrollMethod)
    }

    function setM(val) {
        init(val)
    }
    async function setBC(val) {
        setBankCode(val)
        mPayrollMethod.bankCode = val


        getBankName(val, {
            success: (bankName) => {
                setBankName(bankName)
                mPayrollMethod.bankName = bankName

                setPayrollMethod(index, mPayrollMethod)
            }
        })
    }
    function setBBC(val) {
        setBankBranchCode(val)
        mPayrollMethod.bankBranchCode = val
        setPayrollMethod(index, mPayrollMethod)
    }
    function setBBN(val) {
        setBankBranchName(val)
        mPayrollMethod.bankBranch = val
        setPayrollMethod(index, mPayrollMethod)
    }
    function setAN(val) {
        setAccountName(val)
        mPayrollMethod.accountName = val
        setPayrollMethod(index, mPayrollMethod)
    }
    function setA(val) {
        setAccount(val)
        mPayrollMethod.account = val
        setPayrollMethod(index, mPayrollMethod)
    }
    function setI(val) {
        setIdNumber(val)
        mPayrollMethod.idNumber = val
        setPayrollMethod(index, mPayrollMethod)
    }

    function getBankName(bankCode, { success }) {
        if (bankCode.length === 3) {
            api_getBankName({
                bankCode,
                success: (bankName) => {
                    success(bankName)
                },
                failure: (error) => {
                    Swal.fire({
                        type: 'error',
                        title: '提醒',
                        text: error.message,
                    })
                    success(bankName)
                }
            })

        }
    }
    return (
        <>
            <div className="row m-b-sm">
                <div className="col-md-12">
                    {isEdit ?
                        <SingleSelect title={"領取方式"}
                            val={method}
                            attr={methodItems}
                            action={setM}
                            hasBlank={true}
                        />
                        : <SingleText title={"領取方式"} val={getItemsInfo({ items: methodItems, val: method })} />
                    }
                </div>
            </div>
            <div className={method === "3" ? "hide" : ""}>
                <div className="hr-line-dashed"></div>
                <div className="row">
                    <div className="col-md-12">
                        {isEdit ?
                            <SingleInput title={"銀行代號"} val={bankCode} action={setBC} placeholder={"822"} />
                            : <SingleText title={"銀行代號"} val={bankCode} />
                        }
                        <SingleText title={"銀行名稱"} val={bankName} />
                        {isEdit ?
                            <SingleInput title={"分行代號"} val={bankBranchCode} action={setBBC} placeholder={"0602"} />
                            : <SingleText title={"分行代號"} val={bankBranchCode} />
                        }
                        {isEdit ?
                            <SingleInput title={"分行名稱"} val={bankBranchName} action={setBBN} placeholder={"大安分行"} />
                            : <SingleText title={"分行名稱"} val={bankBranchName} />
                        }
                    </div>
                </div>
                <div className="hr-line-dashed"></div>
                <div className="row">
                    <div className="col-md-12">
                        {isEdit ?
                            <SingleInput title={"帳號"} val={account} action={setA} placeholder={"123456789012345678"} />
                            : <SingleText title={"帳號"} val={account} />
                        }
                        {isEdit ?
                            <SingleInput title={"戶名"} val={accountName} action={setAN} placeholder={accountNamePlaceholder[method]} />
                            : <SingleText title={"戶名"} val={accountName} />
                        }
                        <div className={method === "1" ? "hide" : ""}>
                            {isEdit ?
                                <SingleInput title={"身分證號"} val={idNumber} action={setI} placeholder={"A123456789"} />
                                : <SingleText title={"身分證號"} val={idNumber} />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
